import React from "react";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import { Article } from "./articleHelpers";
import config from "./config";
import { handleEvent } from "./fileUploadHelper";

const Input = styled("input")({
  display: "none",
});

type ArticleMetaFieldsProps = {
  articleMeta: Article;
  setArticleMeta: React.Dispatch<Article>;
  isUploading: boolean;
  uploadIllustration: (illustration: File) => void;
  illustrationPath: string | undefined | null;
};

const ArticleMetaFields: React.FC<ArticleMetaFieldsProps> = ({
  articleMeta,
  setArticleMeta,
  isUploading,
  uploadIllustration,
  illustrationPath,
}) => (
  <Box component="form" noValidate autoComplete="off">
    {[
      ["Titre", "title"],
      ["Description", "subTitle"],
      ["Permalink", "slug"],
    ].map(([label, field]) => (
      <TextField
        fullWidth={field !== "slug"}
        key={label}
        id="outlined-basic"
        value={articleMeta[field as keyof Article]}
        onChange={({ target }) => {
          const newArticleMeta = {
            ...articleMeta,
            [field]: target.value,
          };
          // updateLocally(dispatch, articleId, newArticleMeta, content);
          setArticleMeta(newArticleMeta);
        }}
        sx={{ my: 1 }}
        label={label}
        variant="outlined"
      />
    ))}
    <TextField
      // id="outlined-select-currency"
      select
      sx={{ m: 1, width: "25ch" }}
      label="Blog"
      defaultValue={config.defaultBlog}
      value={articleMeta.blog}
      disabled={!!articleMeta.blog}
      onChange={(event) => {
        const newArticleMeta = {
          ...articleMeta,
          blog: event.target.value,
        };
        // updateLocally(dispatch, articleId, newArticleMeta, content);
        setArticleMeta(newArticleMeta);
      }}
      // helperText="Blog"
    >
      {[config.defaultBlog].map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
    {illustrationPath && (
      <img alt="Illustration" height={100} src={illustrationPath} />
    )}
    <label htmlFor="contained-button-file">
      <Input
        accept="image/jpeg"
        id="contained-button-file"
        onChange={(event) => handleEvent(event, uploadIllustration)}
        type="file"
      />
      <LoadingButton
        loading={isUploading}
        variant="outlined"
        component="span"
        sx={{ my: 2, ml: 2 }}
      >
        {`${illustrationPath ? "Modifier" : "Télécharger"} illustration`}
      </LoadingButton>
    </label>
  </Box>
);

export default ArticleMetaFields;
